module.exports = __webpack_public_path__ + "static/media/loading-bars.84a72c4d.svg";